import * as React from 'react';
import FormViewModal from 'components/common/Modals/FormViewModal';
import { IActionItem } from 'components/common/Modals/FormViewModal.properties';
import AuthroisationForm from './Authorisation.form';

const STYLE_PROPS = {
  height: '460px',
  minWidth: '650px'
} as const;

const Authorisation = (props): JSX.Element => {
  const { open, onOk, onClose, valuesSchema, initialValues, values, mainContent, currentUserId } = props;

  const confirmationActions = (): IActionItem[] => {
    return [
      {
        title: 'Authorise',
        isDefault: true,
        listener: async () => {
          onOk({
            ...mainContent,
            AuthUserId: values.AuthUserId,
            AuthUserPin: values.AuthUserPin,
            AuthorisationPending: values.AuthorisationPending,
            AuthorisationRequired: values.AuthorisationRequired
          });
        }
      },
      {
        title: 'Cancel',
        listener: () => {
          onClose({
            ...mainContent,
            Transmit: false,
            SetStatusToTransmit: false,
            AuthUserId: undefined,
            AuthUserPin: undefined,
            AuthorisationPending: values.AuthorisationPending,
            AuthorisationRequired: values.AuthorisationRequired,
          });
        }
      }
    ];
  };

  return (<FormViewModal
    open={open}
    loading={false}
    title='Authorisation Required'
    formProps={{
      style: STYLE_PROPS,
      formSchema: AuthroisationForm,
      initialValues: {...initialValues, AuthUserId: currentUserId},
      valuesSchema: valuesSchema,
    }}
    actions={confirmationActions()}
    dialogActionsButtons={true}
    dialogActionsShadow={false}

  />);
};

export default Authorisation;
